module.exports = __webpack_public_path__ + "img/RS.e3ecd2f9.png";